import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { THEFT_REGISTRIES_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const createTheftSmsAction = createAsyncThunk(
    'order/createTheftSmsAction',
    async (id, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.post(`${ THEFT_REGISTRIES_PATH }/${ id }/send-sms`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const createTheftSmsSlice = createSlice({
    name: 'createTheftSmsSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(createTheftSmsAction.pending, () => STATE__API__STARTED);
        builder.addCase(createTheftSmsAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(createTheftSmsAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const createTheftSmsState = (state) => state.order.createTheftSms;
export default createTheftSmsSlice.reducer;